import { FunctionComponent } from "react";

import {
  Dialog,
  SubmissionForm,
  TextInputField,
  Stack,
  Text
} from "@bps/fluent-ui";
import {
  CallbackTypesDto,
  IpRangeDto
} from "@libs/api/gateways/plt-integrators/plt-integrators-gateway.dtos";
import { useUpdateCallbackType } from "@libs/api/gateways/plt-integrators/plt-integrators-gateway.hooks";

export interface CallbackTypeDialogProps {
  callbackType: CallbackTypesDto;
  onDismiss: () => void;
}

export interface CallbackTypeFormValues {
  code: string;
  description?: string;
  ipRanges?: IpRangeDto[];
}

export const CallbackTypeDialog: FunctionComponent<CallbackTypeDialogProps> = ({
  callbackType,
  onDismiss
}) => {
  const { mutateAsync: updateCallbackTypes } = useUpdateCallbackType();

  const onSubmit = async (formData: CallbackTypeFormValues) => {
    await updateCallbackTypes({
      code: formData.code,
      description: formData.description,
      ipRanges: formData.ipRanges
    });
    onDismiss();
  };

  const defaultValues = {
    code: callbackType.code,
    description: callbackType.description,
    ipRanges: callbackType.ipRanges
  };

  return (
    <Dialog
      hidden={false}
      dialogContentProps={{
        title: "Configure Callback Type",
        showCloseButton: true,
        onDismiss
      }}
      minWidth={500}
    >
      <SubmissionForm<CallbackTypeFormValues>
        onSubmit={onSubmit}
        initialValues={defaultValues}
        cancelButtonProps={{ onClick: onDismiss }}
      >
        {() => (
          <Stack tokens={{ childrenGap: 50 }} verticalAlign="space-between">
            <Stack tokens={{ childrenGap: 8 }} verticalAlign="space-between">
              <Text>Code: {defaultValues.code}</Text>
              <Text>Description: {defaultValues.description}</Text>
            </Stack>
            <Stack tokens={{ childrenGap: 8 }} verticalAlign="space-between">
              <Stack
                tokens={{ childrenGap: 10 }}
                horizontal
                horizontalAlign="space-between"
              >
                <TextInputField
                  label="Range1"
                  name="ipRanges[0].ipRangeBegin"
                  placeholder="IP Range Begin"
                  width={5}
                />
                <Text>to</Text>
                <TextInputField
                  name="ipRanges[0].ipRangeEnd"
                  placeholder="IP Range End"
                />
              </Stack>
              <Stack tokens={{ childrenGap: 10 }} horizontal>
                <TextInputField
                  label="Range2"
                  name="ipRanges[1].ipRangeBegin"
                  placeholder="IP Range Begin"
                />
                <Text>to</Text>
                <TextInputField
                  name="ipRanges[1].ipRangeEnd"
                  placeholder="IP Range End"
                />
              </Stack>
            </Stack>
          </Stack>
        )}
      </SubmissionForm>
    </Dialog>
  );
};
